export function formatPriceInCentsToDollars(priceInCents: number) {
  const formattingOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  };
  const dollarString = new Intl.NumberFormat('en-US', formattingOptions);
  return dollarString.format((priceInCents || 0) / 100);
}
